import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Spin } from 'antd'
import MyTextArea from '../../../components/forms/textArea'

const ReplyMessage = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({
    replyContent: props.data.reply_content
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleOk = () => {
    setIsLoading(true)
    axios.post('/p/content/message/reply', {
      merchant_oid: merchantOid,
      message_oid: props.data.oid,
      reply_content: formValue.replyContent
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('回复成功！')
          props.isCancel()
          props.getMessageDetail()
          props.getMessageData()
          setIsLoading(false)
        } else {
          message.error(response.msg)
          setIsLoading(false)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal
      title="回复留言"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okText="回复">

      <Spin spinning={isLoading} tip='回复中，请稍等'>
        <MyTextArea
          id="replyContent"
          label='回复内容'
          required={true}
          minRows={4}
          placeholder='请输入回复内容'
          value={formValue.replyContent}
          onChange={setFormValue}
        />
      </Spin>
    </Modal>
  )
}

export default ReplyMessage
